import object from 'helpers/object'


export const initialState = {
  tickets: [],
  isFetching: true,
}


export const setTickets = (state, payload) => (
  object.setIn(state, [ 'tickets' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
